export default __webpack_public_path__ + "static/media/like.44a59ade.png";